import React, { useEffect } from 'react';
import './detallerubro.css';
import { rubros } from '../../json/rubros';
import { useParams } from 'react-router-dom';

const DetalleRubro = () => {

  const { id } = useParams();

  const rubro = rubros.find(
    (r) => r.id === Number(id)
  );

  // Scroll arriba
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Redireccionar SOLO si tiene URL externa
  useEffect(() => {

    if (
      rubro &&
      rubro.url &&
      rubro.url !== "0"
    ) {
      window.location.href = rubro.url;
    }

  }, [rubro]);

  // Validación
  if (!rubro) {
    return (
      <div className="container mt-5">
        <h3>Rubro no encontrado</h3>
      </div>
    );
  }

  return (

    <div className='container container_detalle_rubro'>

      <div className='row'>

        <div className='col-12 mt-5'>

          <div className='rubro_titulo'>
            <h3 className='title'>
              {rubro.nombre}
            </h3>

            <hr className='hr-gob' />
          </div>

        </div>

      </div>

      <div className='row'>

        {
          rubro.formatos.map((formato, index) => {

            const urlXLSX =
              formato.xlsx?.startsWith("http")
                ? formato.xlsx
                : "/xlsx/" + formato.xlsx;

            const urlHTML =
              formato.html?.startsWith("http")
                ? formato.html
                : "/html/" + formato.html;

            return (

              <div
                key={index}
                className='col-md-4 col-12'
              >

                <div className='rubro_container_detalle'>

                  <div className='detalle_rubro_nombre'>
                    <h5>{formato.nombre}</h5>
                  </div>

                  <div className='detalle_rubro_enlaces'>

                    <a
                      href={urlXLSX}
                      target="_blank"
                      rel="noreferrer"
                    >
                      XLSX
                    </a>

                    <a
                      href={urlHTML}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Ver Tabla
                    </a>

                  </div>

                </div>

              </div>

            );

          })
        }

      </div>

    </div>

  );

};

export default DetalleRubro;